<template>
    <div>
        <div class="flex h-screen-header overflow-y-auto">
            <ul class="menu bg-base-100 w-16 md:w-56 my-2 rounded-box">
                <li>
                    <a :class="{ 'active': activeIndex === 1 }" @click="handleActive(1)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
                        <div class="!hidden md:!block">基本设置</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 2 }" @click="handleActive(2)">
                        <svg t="1709776900830" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10126" width="200" height="200"><path d="M304.697598 824.441653a291.891313 291.891313 0 1 1 291.891313-291.891313 292.48701 292.48701 0 0 1-291.891313 291.891313zM304.697598 298.441593a232.321658 232.321658 0 1 0 232.321657 232.321657A232.917354 232.917354 0 0 0 304.697598 298.441593z"></path><path d="M304.697598 674.921817a142.371477 142.371477 0 1 1 141.775781-142.371477 142.371477 142.371477 0 0 1-141.775781 142.371477z m0-224.577602a82.801822 82.801822 0 1 0 82.206125 82.206125A82.801822 82.801822 0 0 0 304.697598 450.344215zM53.909347 677.304603l58.378263-12.509627 74.34293 346.754966-58.378263 12.509628zM537.9128 541.307079l56.769882-17.990036 143.562871 452.550675-56.769882 17.990036zM192.587506 262.401951l494.070725-193.89923 21.742924 55.39978-494.070725 193.958799z"></path><path d="M548.456629 531.001529l283.84941-218.14408 36.33749 47.238737L584.67498 578.240266z"></path><path d="M828.910569 365.755304a182.878843 182.878843 0 1 1 110.799559-327.633107 29.784828 29.784828 0 0 1 11.318235 26.210648 28.593435 28.593435 0 0 1-16.083807 23.827863l-69.100801 36.33749 26.806345 51.229904L965.920777 137.603522a27.997738 27.997738 0 0 1 27.402042 0 29.189131 29.189131 0 0 1 16.083807 22.636469v23.232166a182.283147 182.283147 0 0 1-180.496057 182.283147z m0-305.592334a123.309187 123.309187 0 1 0 119.139311 154.285408l-54.208386 27.997738a29.784828 29.784828 0 0 1-22.63647 0 28.593435 28.593435 0 0 1-17.2752-14.892414l-54.208387-104.246897a29.189131 29.189131 0 0 1 12.509628-39.91167l42.890152-22.040772A131.053243 131.053243 0 0 0 828.910569 60.16297z"></path></svg>
                        <div class="!hidden md:!block">后台刮削</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 3 }" @click="handleActive(3)">
                        <svg t="1709776996533" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11137" width="200" height="200"><path d="M837.864727 560.593455l-14.289454 46.754909a324.724364 324.724364 0 0 1-23.877818 57.460363l-23.016728 43.194182 32.791273 36.352a46.312727 46.312727 0 0 1-1.256727 63.860364 45.451636 45.451636 0 0 1-32.395637 13.265454c-11.682909 0-22.853818-4.258909-31.464727-12.008727l-36.352-32.814545-43.217454 23.04c-18.455273 9.844364-37.794909 17.873455-57.437091 23.877818l-46.754909 14.289454-2.56 48.826182A46.336 46.336 0 0 1 512 930.909091a46.336 46.336 0 0 1-46.033455-44.218182l-2.56-48.826182-46.754909-14.289454a324.491636 324.491636 0 0 1-57.437091-23.877818l-43.217454-23.04-36.352 32.814545c-8.587636 7.749818-19.781818 12.032-31.464727 12.032-12.334545 0-23.831273-4.724364-32.395637-13.288727a46.312727 46.312727 0 0 1-1.256727-63.860364l32.791273-36.352-23.016728-43.217454a323.770182 323.770182 0 0 1-23.877818-57.437091l-14.289454-46.778182-48.826182-2.56A46.359273 46.359273 0 0 1 93.090909 512c0-24.529455 19.432727-44.730182 44.218182-46.033455l48.826182-2.56 14.289454-46.778181c6.004364-19.618909 14.033455-38.935273 23.877818-57.413819l23.016728-43.217454-32.791273-36.352a46.312727 46.312727 0 0 1 1.256727-63.860364 45.451636 45.451636 0 0 1 32.395637-13.288727c11.682909 0 22.877091 4.282182 31.464727 12.032l36.352 32.791273 43.217454-23.04a325.236364 325.236364 0 0 1 57.437091-23.854546l46.754909-14.289454 2.56-48.826182A46.359273 46.359273 0 0 1 512 93.090909c24.529455 0 44.730182 19.432727 46.033455 44.218182l2.56 48.826182 46.754909 14.289454c19.642182 6.004364 38.981818 14.033455 57.437091 23.877818l43.217454 23.016728 36.352-32.814546c8.610909-7.726545 19.781818-12.008727 31.464727-12.008727 12.334545 0 23.831273 4.724364 32.395637 13.265455a46.312727 46.312727 0 0 1 1.256727 63.860363l-32.791273 36.375273 23.016728 43.217454c9.844364 18.478545 17.873455 37.794909 23.877818 57.437091l14.289454 46.754909 48.826182 2.56c24.808727 1.303273 44.218182 21.504 44.218182 46.033455a46.336 46.336 0 0 1-44.218182 46.033455l-48.826182 2.56zM1000.727273 512c0-61.952-49.198545-112.546909-110.382546-115.758545a393.658182 393.658182 0 0 0-29.021091-69.841455c41.076364-45.544727 40.075636-116.154182-3.746909-159.976727a115.2 115.2 0 0 0-81.757091-33.745455 116.596364 116.596364 0 0 0-78.219636 29.998546 394.682182 394.682182 0 0 0-69.841455-29.021091C624.546909 72.448 573.952 23.272727 512 23.272727c-61.952 0-112.546909 49.198545-115.758545 110.382546a395.403636 395.403636 0 0 0-69.841455 29.021091 116.596364 116.596364 0 0 0-78.219636-30.021819 115.2 115.2 0 0 0-81.757091 33.745455c-43.822545 43.845818-44.8 114.455273-3.746909 160a395.403636 395.403636 0 0 0-29.021091 69.818182C72.471273 399.476364 23.272727 450.071273 23.272727 512c0 61.952 49.198545 112.570182 110.382546 115.758545a393.937455 393.937455 0 0 0 29.021091 69.818182c-41.053091 45.568-40.075636 116.177455 3.746909 160a115.2 115.2 0 0 0 81.757091 33.745455 116.596364 116.596364 0 0 0 78.219636-30.021818c22.132364 11.799273 45.474909 21.597091 69.841455 29.044363C399.453091 951.528727 450.048 1000.727273 512 1000.727273c61.952 0 112.546909-49.198545 115.758545-110.382546 24.389818-7.447273 47.709091-17.245091 69.841455-29.021091a116.596364 116.596364 0 0 0 78.219636 29.998546 115.2 115.2 0 0 0 81.757091-33.745455c43.822545-43.822545 44.8-114.432 3.746909-159.976727 11.776-22.109091 21.573818-45.451636 29.021091-69.841455C951.528727 624.570182 1000.727273 573.952 1000.727273 512z m-316.485818 34.909091c-14.289455 0-26.88 8.843636-32.279273 22.085818-22.551273 55.226182-76.730182 94.254545-139.962182 94.254546s-117.410909-39.028364-139.962182-94.254546a34.955636 34.955636 0 0 0-32.279273-22.109091c-24.343273 0-41.844364 24.576-32.791272 47.173818C339.595636 675.444364 419.095273 733.090909 512 733.090909c92.904727 0 172.404364-57.646545 205.032727-139.031273 9.053091-22.597818-8.448-47.150545-32.791272-47.150545z m-344.48291-69.818182c14.289455 0 26.88-8.843636 32.279273-22.109091 22.551273-55.202909 76.730182-94.254545 139.962182-94.254545s117.410909 39.051636 139.962182 94.254545c5.399273 13.265455 17.989818 22.109091 32.279273 22.109091 24.343273 0 41.844364-24.552727 32.791272-47.150545C684.404364 348.578909 604.904727 290.909091 512 290.909091c-92.904727 0-172.404364 57.669818-205.032727 139.031273-9.053091 22.574545 8.448 47.150545 32.791272 47.150545z"></path></svg>
                        <div class="!hidden md:!block">其他设置</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 4 }" @click="handleActive(4)">
                        <svg t="1709777080693" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12709" width="200" height="200"><path d="M768 0a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128h512z m0 64H256a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64z m-32 768v64h-448v-64h448zM512 256a256 256 0 1 1 0 512 256 256 0 0 1 0-512z m0 64a192 192 0 1 0 0 384 192 192 0 0 0 0-384z m0 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM320 128v64H256V128h64z m448 0v64H704V128h64z"></path></svg>
                        <div class="!hidden md:!block">小爱音响</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 5 }" @click="handleActive(5)">
                        <svg t="1709776761281" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6779" width="200" height="200"><path d="M746.666667 725.333333c59.733333-12.8 106.666667-64 106.666666-128 0-72.533333-55.466667-128-128-128-17.066667 0-29.866667 4.266667-42.666666 8.533334V469.333333c0-93.866667-76.8-170.666667-170.666667-170.666666s-170.666667 76.8-170.666667 170.666666c0 17.066667 4.266667 29.866667 4.266667 46.933334-8.533333-4.266667-17.066667-4.266667-25.6-4.266667C260.266667 512 213.333333 558.933333 213.333333 618.666667S260.266667 725.333333 320 725.333333h426.666667z m0 85.333334h-426.666667C213.333333 810.666667 128 725.333333 128 618.666667c0-85.333333 55.466667-157.866667 128-183.466667C273.066667 311.466667 379.733333 213.333333 512 213.333333c110.933333 0 209.066667 72.533333 243.2 170.666667 102.4 12.8 183.466667 102.4 183.466667 213.333333s-85.333333 200.533333-192 213.333334z"></path></svg>
                        <div class="!hidden md:!block">网盘音乐</div>
                    </a>
                </li>
            </ul>
            <div class="flex-1 mx-2 my-2 rounded-2xl bg-base-100 p-8 overflow-y-auto">
                <div v-if="activeIndex === 1">
                    <div class="mb-4">
                        <div class="mb-1">1. 本地音乐标签写入位置:</div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_metadata" @change="HandleUpdateSys('save_in_metadata')" />
                                <span class="label-text">元数据</span>
                            </label>
                        </div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_db" @change="HandleUpdateSys('save_in_db')" />
                                <span class="label-text">数据库</span>
                            </label>
                        </div>
                        <div class="text-gray-400 text-sm">元数据：内嵌进音乐文件中。数据库: 音乐标签提供的数据库</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">2. webdav音乐标签写入位置:</div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_metadata_wb" @change="HandleUpdateSys('save_in_metadata_wb')" />
                                <span class="label-text">元数据</span>
                            </label>
                        </div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_db_wb" @change="HandleUpdateSys('save_in_db_wb')" />
                                <span class="label-text">数据库</span>
                            </label>
                        </div>
                        <div class="text-gray-400 text-sm">元数据：内嵌进音乐文件中。数据库: 音乐标签提供的数据库</div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 2">
                    <div class="mb-4">
                        <div class="mb-1">1. 是否开启后台刮削:</div>
                        <input type="checkbox" class="toggle toggle-sm toggle-primary mb-1" v-model="formData.is_watch_file" @change="HandleUpdateSys('is_watch_file')" />
                        <div class="text-gray-400 text-sm">后台刮削：无需要人工操作，后台对目标目录下的音乐文件进行修改元数据。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">2. 目标目录:</div>
                        <div class="badge badge-primary badge-outline mb-1">/app/media/download/</div>
                        <div class="text-gray-400 text-sm">后台刮削的目标目录，会对该目录下新增的音乐文件进行刮削。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">3. 修改范围:</div>
                        <div class="mb-1">
                            <bk-select style="width: 250px;"
                                searchable
                                multiple
                                show-select-all
                                @change="HandleUpdateSys('silence_modify_list')"
                                v-model="formData.silence_modify_list">
                                <bk-option v-for="option in modifyListBatch"
                                    :key="option.id"
                                    :id="option.id"
                                    :name="option.name">
                                </bk-option>
                            </bk-select>
                        </div>
                        <div class="text-gray-400 text-sm">修改选定的元数据，可支持多选。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">4. 刮削模式:</div>
                        <div class="join">
                            <input class="join-item btn btn-sm" type="radio" name="silent_select_mode" aria-label="宽松模式 | " value="simple" v-model="formData.silent_select_mode" @change="HandleUpdateSys('silent_select_mode')" />
                            <input class="join-item btn btn-sm" type="radio" name="silent_select_mode" aria-label="标准模式 | " value="normal" v-model="formData.silent_select_mode" @change="HandleUpdateSys('silent_select_mode')" />
                            <input class="join-item btn btn-sm" type="radio" name="silent_select_mode" aria-label="严格模式 | " value="hard" v-model="formData.silent_select_mode" @change="HandleUpdateSys('silent_select_mode')" />
                        </div>
                        <div class="text-gray-400 text-sm">同自动刮削中的模式。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">5. 刮削后整理:</div>
                        <div class="pl-4">
                            <div class="flex items-center">
                                <div class="mb-1 mr-2"> 1. 是否刮削后整理:</div>
                                <input type="checkbox" class="toggle toggle-sm toggle-primary mb-1" v-model="formData.is_tag_tidy" @change="HandleUpdateSys('is_tag_tidy')" />
                            </div>
                            <div class="input-demo flex flex-col mb-1">
                                <div class="w-48">2. 整理后根目录: </div>
                                <input v-model="formData.root_path" @change="HandleUpdateSys('root_path')" class="input input-sm input-bordered w-full max-w-xs">
                            </div>
                            <div>
                                <div>3. 目录层级</div>
                                <div class="pl-4">
                                    <div v-for="(input, index) in formData.dir_list" :key="index"
                                        style="margin-top: 10px;">
                                        <div>第{{ index + 1 }}层目录</div>
                                        <div style="display: flex;align-items: center;">
                                            <bk-select style="width: 250px;"
                                                :placeholder="'请选择目录'"
                                                :clearable="false"
                                                @change="HandleUpdateSys('dir_list')"
                                                v-model="input.value">
                                                <bk-option v-for="option in tidyList"
                                                    :key="option.id"
                                                    :id="option.id"
                                                    :name="option.name">
                                                </bk-option>
                                            </bk-select>
                                            <div @click="removeInput(index)">
                                                <bk-icon type="close" style="font-size: 18px;cursor: pointer;"></bk-icon>
                                            </div>
                                        </div>
                                    </div>
                                    <button :theme="'default'" type="submit" :title="'基础按钮'" @click="addInput" class="btn"
                                        style="margin-top: 10px;">
                                        添加目录
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="text-gray-400 text-sm">刮削后将成功匹配的文件整理转移到其他目录下。</div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 3">
                    <div class="mb-4">
                        <div class="mb-1">1. 删除subsonic数据库数据:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask2('music')">清空 subsonic 数据库</button>
                        </div>
                        <div class="text-gray-400 text-sm">删除数据库中的数据，方便调试重新导入。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">2. 全部刮削艺术家封面:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask3">刮削艺术家</button>
                        </div>
                        <div class="text-gray-400 text-sm">全部刮削艺术家封面，可以在艺术家页面单个修改自定义的封面。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">3. 停止所有后台任务:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask1">停止后台任务</button>
                        </div>
                        <div class="text-gray-400 text-sm">强制停止所有后台任务。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">4. 删除所有操作记录:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask2('audit_log')">删除操作记录</button>
                        </div>
                        <div class="text-gray-400 text-sm">删除所有操作记录。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">5. 删除所有播放记录:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask2('play_log')">删除播放记录</button>
                        </div>
                        <div class="text-gray-400 text-sm">删除所有播放记录。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">6. 删除所有刮削记录:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask2('tag_log')">删除刮削记录</button>
                        </div>
                        <div class="text-gray-400 text-sm">删除所有刮削记录，刮削记录用于标记每个音乐的刮削状态。</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">7. 删除不存在的音乐收藏:</div>
                        <div class="mb-1">
                            <button class="btn" @click="handleTask2('remove_track_null')">删除不存在收藏</button>
                        </div>
                        <div class="text-gray-400 text-sm">在数据库中同步删除不存在或已被删除的音乐。</div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 4">
                    <div>接入小爱音箱播放本地音乐</div>
                    <div class="flex flex-wrap">
                        <div class="mt-4 w-1/2">
                            <div>设备型号</div>
                            <input type="text" placeholder="请输入型号" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.mi_hardware_type" @change="HandleUpdateSys('mi_hardware_type')" />
                            <div class="text-gray-400 text-sm">型号在音箱底部标签获取，例如LX06</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>设备名称</div>
                            <input type="text" placeholder="请输入型号" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.mi_hardware_name" @change="HandleUpdateSys('mi_hardware_name')" />
                            <div class="text-gray-400 text-sm">小爱音响设备名称，例如：小爱音箱Pro</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>小米ID</div>
                            <input type="text" placeholder="请输入账号" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.mi_user_id" @change="HandleUpdateSys('mi_user_id')" />
                            <div class="text-gray-400 text-sm">小米账号非手机号</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>账号密码</div>
                            <input type="password" placeholder="请输入密码" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.mi_password" @change="HandleUpdateSys('mi_password')" />
                            <div class="text-gray-400 text-sm">小米账号密码</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>关键字</div>
                            <input type="text" placeholder="请输入关键字" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.mi_keyword" @change="HandleUpdateSys('mi_keyword')" />
                            <div class="text-gray-400 text-sm">识别的唤醒的关键字，呼唤语句：小爱同学 关键字 歌曲名。进行点歌</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>轮询时间</div>
                            <input type="text" placeholder="请输入" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.mi_timeloop" @change="HandleUpdateSys('mi_timeloop')" />
                            <div class="text-gray-400 text-sm">此方法是轮询调用 miservice 来监听说话的数据，设置合适的轮询时间</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>内网地址和端口</div>
                            <input type="text" placeholder="请输入内网地址和端口" class="input input-sm input-bordered w-full max-w-xs"
                                v-model="formData.inner_ip" @change="HandleUpdateSys('inner_ip')" />
                            <div class="text-gray-400 text-sm">拼接成小米音箱播放的 url， 例如：192.168.0.115:8002</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>是否启用</div>
                            <input type="checkbox" class="toggle toggle-primary"
                                v-model="formData.mi_open" @change="HandleUpdateSys('mi_open')" />
                            <div class="text-gray-400 text-sm">此方法是轮询调用miservice接口，不用时关闭较好，以免出现被封号</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <button class="btn btn-sm btn-secondary" @click="linkTest">测试连接</button>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 5">
                    <div class="mt-2">
                        <div>AList Url</div>
                        <input type="text" placeholder="请输入 alist 的 url"
                            @change="HandleUpdateSys('alist_url')"
                            v-model="formData.alist_url"
                            class="input input-sm input-bordered w-full max-w-xs" />
                        <div class="text-gray-400 text-sm">确保该系统可以访问到 alist 地址，例如：http://192.168.0.115:5244</div>
                        <div class="text-gray-400 text-sm">需要完整的音乐文件路径才能播放</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                size: 'small',
                activeIndex: 1,
                data: [],
                pagination: {
                    current: 1,
                    count: 500,
                    limit: 15
                },
                modifyList: '',
                modifyListBatch: [
                    {id: 'artist', name: '艺术家'},
                    {id: 'album', name: '专辑'},
                    {id: 'album_img', name: '专辑封面'},
                    {id: 'year', name: '年份'},
                    {id: 'lyrics', name: '歌词'}
                ],
                formData: {
                },
                saveInMetaData: true,
                saveInDB: false,
                roleList: [],
                tidyList: [
                    {id: 'title', name: '标题'},
                    {id: 'artist', name: '艺术家'},
                    {id: 'album', name: '专辑'},
                    {id: 'album_artist', name: '专辑艺术家'},
                    {id: 'album_type', name: '专辑类型'},
                    {id: 'genre', name: '风格'},
                    {id: 'language', name: '语言'},
                    {id: 'track_number', name: '音轨号'},
                    {id: 'disc_number', name: '光盘编号'},
                    {id: 'comment', name: '描述'}
                ]
            }
        },
        created() {
            this.fetchSysDict()
        },
        methods: {
            handleActive(index) {
                this.activeIndex = index
            },
            fetchSysDict() {
                this.$api.Task.getSysDict().then((res) => {
                    if (res.result) {
                        this.formData = res.data
                    }
                })
            },
            HandleUpdateSys(key) {
                let value = this.formData[key]
                if (value.constructor === Boolean) {
                    console.log(value)
                    value = value ? '1' : '0'
                }
                if (key === 'silence_modify_list') {
                    value = value.join(',')
                } else if (key === 'dir_list') {
                    value = JSON.stringify(value)
                }
                this.$api.Task.UpdateSys({'key': key, value: value}).then((res) => {
                    console.log(res)
                })
            },
            handleTask1() {
                this.$api.Task.debugTask1().then((res) => {
                    if (res.result) {
                        this.$cwMessage('修改成功', 'success')
                    }
                })
            },
            handleTask2(v) {
                this.$api.Task.debugTask2({'mode': v}).then((res) => {
                    if (res.result) {
                        this.$cwMessage('修改成功', 'success')
                    }
                })
            },
            handleTask3() {
                this.$api.Task.batchAutoUpdateArtist().then((res) => {
                    if (res.result) {
                        this.$cwMessage('修改成功', 'success')
                    }
                })
            },
            linkTest() {
                this.$api.Task.miServiceTest().then((res) => {
                    if (res.result) {
                        this.$cwMessage('测试发送成功', 'success')
                    } else {
                        this.$cwMessage(res.message, 'error')
                    }
                })
            },
            addInput() {
                this.formData.dir_list.push({value: ''}) // 添加新的输入框
            },
            removeInput(index) {
                this.formData.dir_list.splice(index, 1) // 删除指定索引的输入框
                this.HandleUpdateSys('dir_list')
            }
        }
    }
</script>
<style lang="postcss">
.bk-table-header .custom-header-cell {
    color: inherit;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-position: under;
}
</style>
